import { faAngleDown as lightAngleDown } from "@jewlr/pro-light-svg-icons/faAngleDown"
import { faAngleRight as lightAngleRight } from "@jewlr/pro-light-svg-icons/faAngleRight"
// import { faFlowerTulip } from "@jewlr/pro-light-svg-icons/faFlowerTulip"
import { faGift } from "@jewlr/pro-light-svg-icons/faGift"
import { faTimes as lightTimes } from "@jewlr/pro-light-svg-icons/faTimes"
// import { faBoxHeart } from "@jewlr/pro-regular-svg-icons/faBoxHeart"
import PropTypes from "prop-types"
import { Fragment, useState } from "react"
import { connect, useSelector } from "react-redux"
import { Link } from "react-router-dom"

import { ItemAction as RemoveItem } from "areas/cart/components"
import { removeLineItem } from "areas/cart/store/actions"
import { openModal } from "components/modal"
import Button from "components/ui/button"
import Confirmation from "components/ui/confirmation"
import Expand from "components/ui/expand"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { isTestMode, IS_JEWLR, jewlr_t } from "helpers/application"
import { to_currency } from "helpers/number"
import { cn } from "styles/utils"

import {
  ItemAction,
  CardItemInfo,
  CardTitle,
  Card,
  CardRemove,
  CardProductImage,
  CardProductImageContainer,
  OutOfStockLabel,
} from "../components"
import GiftOptions from "../gift-wrap/gift-options"
import Price from "../jewlr/price"
import LineItemShipping from "../line-item-shipping"
import WarrantyAddon from "../warranty/warranty-addon"

import LineItemAddon from "./line-item-addon"

const Detail = ({ className = "", ...props }) => (
  <div className={cn("text-12 tracking-half mb-5", className)} {...props} />
)

// const GuaranteedText = styled(Box).attrs({
//   as: "span",
// })`
//   color: ${(props) => props.theme.colors.guaranteed};
//   font-style: italic;
// `

const InternalLineItemMobile = ({ item, removeItem }) => {
  const [showDetails, toggleDetails] = useState(false)
  const [showRemoveDialog, toggleRemoveDialog] = useState(false)
  // const forHer = item.product_gender === "female"
  const cartWarrantyExp = useSelector(
    (state) => state.experiment.cartWarranty.variant_id
  )

  const outOfStock = !item.in_stock

  return (
    <>
      <Card>
        <CardRemove
          aria-label={`Remove ${item.title} from cart`}
          data-cy={`cart-remove-btn-mobile-${item.style_code}`}
          onClick={() => toggleRemoveDialog(true)}
        >
          <FontAwesomeIcon icon={lightTimes} />
        </CardRemove>
        <Confirmation
          cancelText="Cancel"
          confirmText="Yes"
          description={`Are you sure you want to remove this item from your ${jewlr_t("Cart")}?`}
          onCancel={() => toggleRemoveDialog(false)}
          onConfirm={() => {
            removeItem(item.id)
            toggleRemoveDialog(false)
          }}
          show={showRemoveDialog}
          title="Remove Item"
        />

        <CardTitle data-lc="line-items" to={item.modify_url}>
          {item.title}
        </CardTitle>
        {item.holiday_availability && !outOfStock && (
          <div className="flex items-center justify-center pb-2 pt-16">
            <FontAwesomeIcon className="text-sale text-16 mr-8" icon={faGift} />
            <p className="text-sale text-16 tracking-tigher font-semibold">
              {/* <Box
              as="img"
              height="16px"
              mr="1px"
              src={require("images/icons/doublehearts_bold.svg")}
              verticalAlign="text-top"
              width="auto"
            />{" "} */}
              Arrives Before{" "}
              {sl.config.guaranteed_holiday_alias ||
                sl.config.guaranteed_holiday}
              {/* Arrives{" "}
            {new Date(item.min_delivery_date).getDate() ===
            new Date(sl.config.guaranteed_receive_date).getDate()
              ? "By"
              : "Before"}{" "}
            {sl.config.guaranteed_holiday} */}
            </p>
          </div>
        )}
        <div className="flex items-start justify-between py-16">
          <Link data-lc="line-items" to={item.modify_url}>
            <CardProductImageContainer outOfStock={outOfStock}>
              <CardProductImage
                alt={item.title}
                data-cy={`cart-line-item-img-mobile-${item.style_code}`}
                data-sku={item.sku}
                ratio="120 / 120"
                src={item.image_url}
              />
              {outOfStock && <OutOfStockLabel>Out Of Stock</OutOfStockLabel>}
            </CardProductImageContainer>
          </Link>
          <CardItemInfo className="ml-8 items-end text-right">
            {outOfStock ? (
              <RemoveItem
                className="font-medium"
                data-cy={`cart-remove-btn-mobile-${item.style_code}`}
                onClick={() => toggleRemoveDialog(true)}
              >
                Remove from {jewlr_t("Cart")}
              </RemoveItem>
            ) : (
              <>
                <Price dataCyType="mobile" item={item} />
                <LineItemShipping item={item} />
                {!item.reject_addons &&
                  IS_JEWLR() &&
                  sl.config.enable_gift_preview_video && (
                    <Button
                      className="text-12 font-light"
                      onClick={() => {
                        openModal(`#gift-preview-video-${item.id}`)
                        if (!isTestMode) {
                          dataLayer.push({
                            event: "clicked-need-it-now-cart",
                          })
                        }
                      }}
                      text
                      underline
                      variant="secondary"
                    >
                      Need it now? Send a Gift Preview Video
                    </Button>
                  )}
              </>
            )}
          </CardItemInfo>
        </div>

        {!outOfStock && (
          <>
            <div className="text-primary mb-10 flex justify-between">
              {item.view_item_details.length > 0 && (
                <ItemAction
                  aria-controls={`cart-item-details-mobile-${item.id}`}
                  aria-expanded={showDetails}
                  onClick={() => toggleDetails(!showDetails)}
                >
                  Item Details{" "}
                  <FontAwesomeIcon
                    className="align-text-bottom"
                    icon={showDetails ? lightAngleDown : lightAngleRight}
                  />
                </ItemAction>
              )}
              <ItemAction asChild>
                <Link
                  data-cy={`mobile-cart-modify-btn-${item.style_code}`}
                  data-lc="line-items"
                  to={item.modify_url}
                >
                  Modify Item{" "}
                  <FontAwesomeIcon
                    icon={lightAngleRight}
                    style={{ verticalAlign: "text-bottom" }}
                  />
                </Link>
              </ItemAction>
            </div>
            <Expand
              id={`cart-item-details-mobile-${item.id}`}
              show={showDetails}
            >
              <div className="pb-20">
                {item.view_item_details.map((detail) => (
                  <Fragment key={`mobileItemDetails-${detail.name}`}>
                    {detail.values ? (
                      <>
                        <Detail>{!!detail.label && `${detail.label}: `}</Detail>
                        {detail.values.map((value) => (
                          <p className="text-12 tracking-half mb-4" key={value}>
                            - {value}
                          </p>
                        ))}
                      </>
                    ) : (
                      <Detail>
                        {!!detail.label && `${detail.label}: `}
                        <span
                          dangerouslySetInnerHTML={{ __html: detail.value }}
                        />
                        {detail.price !== 0 && detail.name === "de" && (
                          <span> ({to_currency(detail.price)})</span>
                        )}
                        {detail.price !== 0 && detail.name !== "de" && (
                          <span> (+{to_currency(detail.price)})</span>
                        )}
                      </Detail>
                    )}
                  </Fragment>
                ))}
              </div>
            </Expand>
            {IS_JEWLR() && !outOfStock && (
              <>
                {cartWarrantyExp === 1 ? (
                  <>
                    {!item.reject_addons &&
                      sl.config.enable_extend_warranty &&
                      IS_JEWLR() && <WarrantyAddon item={item} />}
                    {!item.reject_addons && IS_JEWLR() && (
                      <GiftOptions item={item} />
                    )}
                  </>
                ) : (
                  <>
                    {!item.reject_addons && IS_JEWLR() && (
                      <GiftOptions item={item} />
                    )}
                    {!item.reject_addons &&
                      sl.config.enable_extend_warranty &&
                      IS_JEWLR() && <WarrantyAddon item={item} />}
                  </>
                )}
              </>
            )}
          </>
        )}
      </Card>
      {IS_JEWLR() && !outOfStock && (
        <LineItemAddon
          addon={item.addons.find((a) => a.addon_type === "BOX_PRINT")}
          item={item}
          itemId={item.id}
        />
      )}
    </>
  )
}

InternalLineItemMobile.propTypes = {
  item: PropTypes.object,
  removeItem: PropTypes.func,
}
Detail.propTypes = {
  className: PropTypes.string,
}
const mapStateToProps = () => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return {
    removeItem: (itemId) => {
      dispatch(removeLineItem(itemId, "product"))
    },
  }
}

const LineItemMobile = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalLineItemMobile)

export default LineItemMobile
